import Button from "@pathwright/ui/src/components/button/Button"
import AssessmentEditorView from "assessments/admin/views/assessment-editor"
import Assessment from "assessments/models/assessment"
import { wrapMarionetteView } from "lib/core/react/react-utils"
import React from "react"
const AssessmentEditor = wrapMarionetteView(
  AssessmentEditorView,
  {},
  "AssessmentEditor"
)

class ManageAssessmentEditor extends React.Component {
  static displayName = "ManageAssessmentEditor"
  state = { assessment: null }

  loadNewAssessment = () => {
    const assessment = new Assessment({}, { isAdmin: true })
    return this.setState({ assessment })
  }

  onAssessmentUpdated = (assessment, questions) => {}

  // Force reload step content, probably not super effecient
  //App.getStore("step").action.loadContent(yes)

  loadAssessment = (stepID, contentID) => {
    return window.App.request("get:assessment", contentID, {
      stepID,
      isAdmin: true
    }).then((assessment) => {
      return this.setState({ assessment })
    })
  }

  componentDidMount() {
    // break encapsulation because reasons.
    const stepStore = window.App.getStore("step")
    const stepID = stepStore.get("step").sourceID()
    const contentID = __guard__(stepStore.get("content"), (x) => x.id)
    if (contentID) {
      return this.loadAssessment(stepID, contentID)
    } else {
      return this.loadNewAssessment()
    }
  }

  onDone = () => {
    const data = this.state.assessment.toJSON()
    return window.App.getStore("contentAdmin")
      .action.saveContent(data)
      .promise.then(() =>
        window.App.getStore("step").action.loadContent({ forceReload: true })
      )
  }

  render() {
    return (
      <div>
        <div className="ContentMethod__FormWrapper">
          {this.state.assessment ? (
            <AssessmentEditor
              model={this.state.assessment}
              onSave={this.onAssessmentUpdated}
            />
          ) : undefined}
        </div>
        <footer className="AssessmentEditor__footer">
          <Button onClick={this.onDone}>Done Editing</Button>
        </footer>
      </div>
    )
  }
}

export default ManageAssessmentEditor

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
